/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrGPTsTypename = "PhrGPTs" as const;

/**
 *
 * @export
 * @interface PhrGPTs
 */
export interface PhrGPTs {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGPTs
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrGPTs
   */
  ultravioletVisibleAbsorptionSpectroscopy?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrGPTs
   */
  readonly __typename?: string;
}

export function PhrGPTsFromJSON(json: any): PhrGPTs {
  return PhrGPTsFromJSONTyped(json, false);
}

export function PhrGPTsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrGPTs {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrGPTsTypename,

    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    ultravioletVisibleAbsorptionSpectroscopy: !exists(json, "ultraviolet_visible_absorption_spectroscopy")
      ? undefined
      : PhrMeasurementFromJSON(json["ultraviolet_visible_absorption_spectroscopy"]),
  };
}

export function PhrGPTsToJSON(object?: PhrGPTs | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    other: PhrMeasurementToJSON(value.other),
    ultraviolet_visible_absorption_spectroscopy: PhrMeasurementToJSON(value.ultravioletVisibleAbsorptionSpectroscopy),
  };
}
